


<script>
    import LeaderboardFull from "./leaderboard-full.svelte";
    import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    CardTitle,
    Modal,
    Input,
  } from "sveltestrap";
</script>
<div class="page-content">
    <Container fluid>
      <!-- <Breadcrumbs title="홈" breadcrumbItem="Dashboard" /> -->
      <Row>
        <Col lg="12">
            <LeaderboardFull />
        </Col>
      </Row>
    </Container>
  </div>